import React from "react";

export default function VoiceAssistantCard() {
  return (
    <section className="bg-white rounded-xl shadow-lg flex flex-col md:flex-row items-center justify-between p-8 md:p-12 gap-8">
      <img
        src="https://storage.googleapis.com/a1aa/image/34a6bde4-aafa-494e-3143-9d24253b512a.jpg"
        alt="Man with tablet"
        className="w-[250px] h-[350px] object-contain"
        width="250"
        height="350"
      />
      <div className="flex flex-col items-center md:items-center gap-4">
        <button
          aria-label="Start voice assistant"
          className="bg-[#f3f5ff] shadow-md rounded-full w-20 h-20 flex items-center justify-center hover:shadow-lg transition-shadow"
        >
          <i className="fas fa-microphone text-[#3b56f5] text-2xl"></i>
        </button>
        <p className="text-center text-sm text-gray-600 max-w-xs">
          Click to start Realtime Voice Assistant
        </p>
      </div>
      <div className="text-[#3b56f5] text-center md:text-right max-w-xs">
        <h1 className="font-extrabold text-2xl leading-tight">
          Hello, Smith!
        </h1>
        <p className="text-base font-normal mt-1">I am Rooboo Voice AI.</p>
      </div>
    </section>
  );
}